const pre ="https://www.backenddata.h2ndigital.com/";

const checkUserApi=`${pre}checkSubscription`;
export {checkUserApi};

// const getQuestionApi=`${pre}question`;
// export {getQuestionApi};

const getQuestionApi = `https://portalbackend.mtnbigcash.com/api/v1/question`
export {getQuestionApi}

const redeemDataApi=`${pre}sendRedeemData`;
export {redeemDataApi};

const redeemPriceApi=`https://www.gamewinnig.gamesawaari.com/Urls?action=4&`;
export {redeemPriceApi};

const reduceUserChanceApi=`${pre}reduceChance`;
export {reduceUserChanceApi};

const faqApi=`${pre}faq`;
export {faqApi};

const termsApi=`${pre}terms`;
export {termsApi};

const scoreApi = `https://portalbackend.mtnbigcash.com/saveScore`
export {scoreApi};


const verifyUser = `https://portalbackend.mtnbigcash.com/verifyUser`;
export {verifyUser}